import React, { Fragment } from 'react'

const scheduleText = 'would like you to set your available appraisal inspection times.'
const bothText = 'would like you to provide additional information prior to the home appraisal.'

const getPayText = (borrower_payment_text) => {
  return `would like you to complete the payment for your ${borrower_payment_text}.`
}

const introText = (permissions, borrower_payment_text) => {
  switch (permissions) {
    case 'schedule':
      return scheduleText
    case 'payment':
      return getPayText(borrower_payment_text)
    default:
      return bothText
  }
}

const Intro = ({
  name,
  permissions,
  branchName,
  lenderName,
  borrower_payment_text,
  additionalText,
  changeStep,
}) => {
  const lenderDisplayName = branchName || lenderName
  return (
  <div className='flex-container text-center' data-testid="welcome-page">
    <div className="box">
      <h1 data-testid="welcome-page-header">Hi {name}</h1>
      { permissions
        ? <Fragment>
        <p className="info" data-testid="welcome-page-instructions">
          {lenderDisplayName} {introText(permissions, borrower_payment_text)}
        </p>
        <p>Let&apos;s get started</p>
        {additionalText}
        {changeStep && (
          <div className="button" onClick={() => changeStep()} data-testid="welcome-continue-button">
            Continue
          </div>
        )} </Fragment>
        : <p className='info' data-testid="welcome-invalid-link-message">
          It looks like {lenderDisplayName} requested information from you in the past,
          but it may no longer be necessary. This link is now invalid.
          If you think this is a mistake, please contact {lenderDisplayName}.
        </p>
      }
    </div>
  </div>
  )
}

export default Intro
